import { render, staticRenderFns } from "./chushou.vue?vue&type=template&id=4941568f"
import script from "./chushou.vue?vue&type=script&lang=js"
export * from "./chushou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports